// extracted by mini-css-extract-plugin
module.exports = {"common-badge-styles":"style_common-badge-styles__25t9c","badgeActive":"style_badgeActive__2REg_","badge":"style_badge__2qflW"};